import React, {useState} from 'react';
import {Formik, Field, FormikProps, FormikHelpers} from 'formik';
import {Link} from 'react-router-dom';

import {Layouts, Button, Form, Modal} from '@components';
import {Props} from './types';
import paths from '@paths';
import utils from '@utils';
import * as hooks from './hooks';
import validations from '@validations';

import * as handlers from './handlers';

import './index.scss';

const Main: React.FC<Props> = props => {
  const [activeDimmer, setActiveDimmer] = useState(false);
  const initialValues = {email: '', password: ''};
  const [isSignUpModal, setIsSignUpModal] = useState(false);
  const [isResetPasswordModal, setIsResetPasswordModal] = useState(false);
  const [cognitoUser, setCognitoUser] = useState({});

  hooks.useMount(props, setActiveDimmer, setIsSignUpModal);

  return (
    <div className="a__sign-in">
      <Layouts.Header.Before
        history={props.history}
        location={props.location}
        match={props.match}
      />
      <div className="w__sign-in-form">
        <div className="b__sign-in-title">ログイン</div>
        <Formik
          initialValues={initialValues}
          onSubmit={(value, formikAction) => {
            handlers.signInEmail(
              value,
              formikAction,
              setIsResetPasswordModal,
              setCognitoUser
            );
          }}
          validate={validations.signIn.main}
        >
          {(formProps: FormikProps<any>) => {
            return (
              <>
                <div className="w__forms">
                  <div className="w__sign-in-input">
                    <Field
                      component={Form.Input}
                      placeholder="メールアドレス"
                      name="email"
                      disabled={formProps.isSubmitting}
                    />
                  </div>
                  <div className="w__sign-in-input">
                    <Field
                      component={Form.Input}
                      placeholder="パスワード"
                      type="password"
                      maxLength={20}
                      disabled={formProps.isSubmitting}
                      name="password"
                    />
                  </div>
                  <div className="w__confirm-button">
                    <Button.Normal
                      text="ログイン"
                      color="yellow"
                      rounded
                      className="b__sign-in-button"
                      disabled={formProps.isSubmitting}
                      loading={formProps.isSubmitting}
                      onClick={() => formProps.handleSubmit()}
                    />
                  </div>
                  <div className="w__link first">
                    <Link to={paths.signUp.main} className="b__link">
                      新規登録がまだの方はこちら
                    </Link>
                  </div>
                  <div className="w__link">
                    <Link to={paths.resetPassword.main} className="b__link">
                      パスワードをお忘れの方はこちら
                    </Link>
                  </div>
                  <div className="w__link">
                    <Link to={paths.signUp.resendConfirm} className="b__link">
                      認証コードの再送信はこちら
                    </Link>
                  </div>
                </div>
                <div className="w__divider">
                  <div className="b__divider" />
                  <div className="b__divider-text">または</div>
                  <div className="b__divider" />
                </div>
                <div className="w__sns-buttons">
                  <Button.SNS
                    type="google"
                    disabled={formProps.isSubmitting}
                    signIn
                    onClick={() => {
                      utils.auth.signInWitSNS('Google');
                    }}
                  />
                  <Button.SNS
                    type="amazon"
                    disabled={formProps.isSubmitting}
                    signIn
                    onClick={() => {
                      utils.auth.signInWitSNS('LoginWithAmazon');
                    }}
                  />
                  <Button.SNS
                    type="facebook"
                    disabled={formProps.isSubmitting}
                    signIn
                    onClick={() => {
                      utils.auth.signInWitSNS('Facebook');
                    }}
                  />
                </div>
              </>
            );
          }}
        </Formik>
      </div>
      <Layouts.Footer.Main />
      <Layouts.Dimmer.Main active={activeDimmer} />
      <Modal.SignUp
        isModal={isSignUpModal}
        handleCloseModal={async () => {
          await utils.amplify.signOut();
          setIsSignUpModal(false);
        }}
        title="基本情報登録"
      />
      <Modal.ChangePassword
        isInitial
        title="初期パスワード変更"
        isModal={isResetPasswordModal}
        handleCloseModal={setIsResetPasswordModal}
        handleSubmit={(value: any, formikHelpers: FormikHelpers<any>) =>
          handlers.resetInitialPassword(
            value,
            formikHelpers,
            setIsResetPasswordModal,
            cognitoUser
          )
        }
      />
    </div>
  );
};

export default Main;
